import { FC } from 'react';
import { registerDataType } from '../RegisterForm';
import { Button, Divider, Flex, Form, Input, Typography } from 'antd';
import AuthTitleAndDescription from '../../AuthTitleAndDescription';
import MobileAppLinks from '../../MobileAppLinks';
import Oauth from '../../Oauth';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

interface EmailFromStepProps {
  registerData: registerDataType;
  nextStep: () => void;
  addRegisterData: (data: Partial<registerDataType>) => void;
}

const EmailFormStep: FC<EmailFromStepProps> = ({
  nextStep,
  addRegisterData,
  registerData,
}) => {
  const intl = useIntl();
  const onFinish = (values: Partial<registerDataType>) => {
    addRegisterData(values);
    nextStep();
  };
  const [form] = Form.useForm<Partial<registerDataType>>();
  const email = Form.useWatch('email', form);
  // const { Link } = Typography;
  return (
    <div className="space-y-4">
      <AuthTitleAndDescription
        titleAndDescription={{
          title: intl.formatMessage({ id: 'welcomeLookfindr' }),
          description: intl.formatMessage({ id: 'idealSolution' }),
        }}
      />
      {/* <Oauth /> */}
      <div className=" text-center ">
        <Divider className="bg-[#9CABC2] my-0 " />
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={registerData}
      >
        <Form.Item
          name={'email'}
          label={intl.formatMessage({ id: 'email' })}
          colon={false}
          required={false}
          hasFeedback
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: 'enterEmail' }),
            },
            {
              type: 'email',
              message: intl.formatMessage({ id: 'invalidEmail' }),
            },
          ]}
        >
          <Input placeholder={intl.formatMessage({ id: 'enterEmail' })} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="w-full my-2">
            {intl.formatMessage({ id: 'registerNow' })}
          </Button>
        </Form.Item>
      </Form>
      <Flex justify="center" className="">
        <p className="text-sec-title text-center text-base ">
          {intl.formatMessage({ id: 'haveAccount' })}{' '}
          <Link className="text-txt-link font-semibold" to="/login">
            {intl.formatMessage({ id: 'loginToYourAccount' })}
          </Link>
        </p>
      </Flex>
      <div className="">
        <Divider className="bg-[#9CABC2] my-0 " />
      </div>
      <MobileAppLinks />
    </div>
  );
};

export default EmailFormStep;
